import { render } from "./Workspace.vue?vue&type=template&id=14c36d84"
import script from "./Workspace.vue?vue&type=script&lang=js"
export * from "./Workspace.vue?vue&type=script&lang=js"
script.render = render

export default script